<template>
  <main>
    <section class="admin-page">
      <div class="admin-toolbar">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          solo
          flat
          dense
          hide-details
          placeholder="Buscar produção..."
          background-color="surface_tertiary"
          v-model="filtro_texto"
          class="admin-search"
        />
        <InserirProducao :fetchData="fetchData" />
      </div>
      <div class="admin-table-wrapper">
        <DataTables
          v-if="producoes"
          :data="filteredProducoes"
          :headers="headers"
          :fetchData="fetchData"
          tab="producoes"
        />
      </div>
    </section>
  </main>
</template>

<script>
import DataTables from "../components/DataTables.vue";
import InserirProducao from "@/components/Modal/Producao/InserirProducao.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProducoesView",
  components: { DataTables, InserirProducao },
  data() {
    return {
      page: 1,
      size: 20,
      filtro_texto: "",
      flg_ativo: "",
      isModalVisible: false,
      tableData: [],
      timer: null,
      modalData: {
        sig_producao: "",
        dsc_producao: "",
        cod_praca: null,
        cod_producao: null,
        editar: false,
      },
      headers: [
        {
          text: "Nome",
          align: "start",
          sortable: false,
          name: "nome",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Sigla",
          sortable: false,
          name: "sigla",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Status",
          sortable: false,
          name: "status",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Descrição",
          sortable: false,
          name: "description",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "ID Campanha",
          sortable: false,
          name: "id_campanha",
          class: " subtitle-1 font-weight-bold text-center",
          value: "name",
        },
        {
          text: "Ações",
          sortable: false,
          name: "actions",
          align: "end",
          class: "subtitle-1 font-weight-bold",
          value: "name",
        },
      ],
    };
  },
  beforeCreate() {
    this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
    this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters({
      producoes: "producoes/getterProducoes",
    }),
    totalPages() {
      let pages = null;
      if (this.producoes) {
        pages = this.producoes.totalPages;
      }
      return pages;
    },
    filteredProducoes() {
      const items = this.producoes.items || [];
      const ordered = [...items].sort((a, b) => {
        // Active productions first, then by name.
        const ativoDiff = (b.flg_ativo === "S") - (a.flg_ativo === "S");
        if (ativoDiff !== 0) return ativoDiff;
        return (a.nome_producao || "").localeCompare(b.nome_producao || "");
      });
      if (this.filtro_texto) {
        const q = this.filtro_texto.toLowerCase();
        return ordered.filter((item) => {
          return (
            (item.nome_producao || "").toLowerCase().includes(q) ||
            (item.sig_producao || "").toLowerCase().includes(q) ||
            (item.dsc_producao || "").toLowerCase().includes(q)
          );
        });
      }
      return ordered;
    },
  },
  methods: {
    ...mapActions({
      getProducoes: "producoes/getProducoes",
    }),
    async fetchData() {
      await this.getProducoes({
        page: 1,
        filtro_texto: "",
        flg_ativo: "",
        dsc_login_usuario: this.$store.state.users.user.dsc_login_usuario,
        isAdmin: this.$store.getters["users/isAdm"] ? true : false,
      });
    },
  },
};
</script>

